module.exports = __webpack_public_path__ + "media/application/images/2018/insta-red-a20e666cbf55ce2dd2d362b45fa18358.svg";